import { Box, Heading, SimpleGrid, VStack, Text, Icon } from '@chakra-ui/react';
import { FaHeart, FaBook, FaHome } from 'react-icons/fa';

const KeyPassionsSection = () => (
  <Box
    py={10}
    px={6}
    bg="pastelGreen"
    shadow="sectionShadow"
    borderRadius="lg"
    my={6}
  >
    <Heading textAlign="center" fontSize="2xl" color="white" mb={6}>
      My Passions
    </Heading>
    <SimpleGrid columns={[1, 2, 3]} spacing={10}>
      {/* Card 1 */}
      <VStack
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="softShadow"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'strongShadow' }}
        transition="all 0.3s ease-in-out"
        textAlign="center"
      >
        <Icon as={FaHeart} boxSize={8} color="pastelPink" />
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          Teaching Biblical Truth
        </Text>
        <Text fontSize="sm" color="gray.500">
          Helping others explore the beauty of God’s word.
        </Text>
      </VStack>

      {/* Card 2 */}
      <VStack
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="softShadow"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'strongShadow' }}
        transition="all 0.3s ease-in-out"
        textAlign="center"
      >
        <Icon as={FaBook} boxSize={8} color="pastelBlue" />
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          Encouraging Women
        </Text>
        <Text fontSize="sm" color="gray.500">
          Supporting women to find real hope in Jesus.
        </Text>
      </VStack>

      {/* Card 3 */}
      <VStack
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="softShadow"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'strongShadow' }}
        transition="all 0.3s ease-in-out"
        textAlign="center"
      >
        <Icon as={FaHome} boxSize={8} color="pastelGreen" />
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          Family Time
        </Text>
        <Text fontSize="sm" color="gray.500">
          Cherishing moments with loved ones at home.
        </Text>
      </VStack>
    </SimpleGrid>
  </Box>
);

export default KeyPassionsSection;
